import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExitToApp from '@material-ui/icons/ExitToApp'
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import StoreIcon from '@material-ui/icons/Store';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PhotoIcon from '@material-ui/icons/Photo';
import PersonPinIcon from '@material-ui/icons/PersonPinCircle';
import Avatar from '@material-ui/core/Avatar';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';

import FileUploader from 'react-firebase-file-uploader';

import _ from "lodash";
import firebase from '../../Firebase';
//import AsyncStorage from '@callstack/async-storage';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

const drawerWidth = 240;

const styles = theme => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#f2a811',
      borderRadius: '5px',
    }
  },
  hide: {
    display:'none',
  },
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: '#f2a811',
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  toolbarAvatar: {
    borderRadius: 0,
    width: 170,
    left: 10,
  },
  toolbarIconButton:{
    right:0,
    position:'absolute'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  loadingColorPrimary: {
    backgroundColor: '#f2a811',
  },
  loadingBarColorPrimary: {
    backgroundColor: '#b1730d',
  },
  uploadingProgress: {
    color: '#f2a811',
    zIndex: 999,
  },
  uploadingProgressTxt: {
    color: '#f2a811',
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: '#fff',
    width: 170,
    height: 170,
    borderRadius: 0,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing.unit,
  },
  label: {
    '&$cssFocused': {
      color: '#f2a811',
    },
  },
  input: {
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  checkbox: {
    color: '#f2a811',
    '&$checked': {
      color: '#f2a811',
    },
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    color: '#fff',
    backgroundColor: '#f2a811',
    '&:hover': {
      backgroundColor: '#b1730d',
    },
    width: 400
  },
  buttonProgress: {
    color: "#fff",
  },
  div_100p:{
    width: "100%",
    marginTop: 15,
    marginBottom: 15,
  },
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#f2a811',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

class Wallet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      drawer: true,
      config:{},
      payout_transactions:[],
      loading: true,
    }
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onMapClick = this.onMapClick.bind(this);
  }

  componentWillMount(){
    /*AsyncStorage.getItem("user").then(u => {
      if(u) {
        let t = this;
        let user = JSON.parse(u);

        if(!(!user.roles.includes("admin") && user.roles.includes("seller")))
          this.props.navigation.navigate("Inventory");

        firebase.firestore().collection("config").onSnapshot(function(docs) {
          let config = [];
          docs.forEach(doc => {
            let c = JSON.parse(doc._document.data.toString());
            c.id = doc.id;
            config.push(c);
          });
          t.setState({config:config[0]});
        });

        firebase.firestore().collection('transactions').onSnapshot(function(docs) {
          let payout_transactions = [];
          docs.forEach(doc => {
            let transaction = JSON.parse(doc._document.data.toString());
            transaction.id = doc.id
            if(transaction.type == "payout")
              payout_transactions.push(transaction);
          });
          t.setState({payout_transactions:payout_transactions, user:user, loading:false});
        });
      } else
        this.props.navigation.navigate('Login');
    });*/
  }

  async logout(){
    try {
     // await AsyncStorage.removeItem('user');
      this.props.navigation.navigate('Login');
    } catch (error) {
      console.log(error);
    }
  }

  toggleDrawer(){
    this.setState({ drawer:!this.state.drawer });
  }

  toggleSwitch(){
    firebase.firestore().collection("config").doc(this.state.config.id).update({
      shop_status: this.state.config.shop_status == "OPEN" ? "CLOSE" : "OPEN",
    }).then(() => {
    }).catch( error => {
      console.log(error);
    });
  }

  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  }

  onMapClick = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      });
    }
  }

  goTo(p){
    this.props.navigation.navigate(p);
  }

  checkPayoutTableRows(ptr){
    let totalUndefined = 0;

    ptr.map(o => {
      if(o == undefined)
        totalUndefined++;
    });

    if(ptr.length == totalUndefined)
      return true
    else
      return false
  }

  render() {
    const { classes } = this.props;   
    let config = this.state.config;
    let payout_transactions = this.state.payout_transactions;
    let payoutTableRows;

    if(!_.isEmpty(payout_transactions)){
      payoutTableRows = payout_transactions.map((pt, i) => {
        return (
          <TableRow key={i}>
            <TableCell component="th" scope="row" />
            <TableCell component="th" scope="row">{ pt.id }</TableCell>
            <TableCell component="th" scope="row">{ pt.amount }</TableCell>
          </TableRow>
        )
      });
    }

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, this.state.drawer && classes.appBarShift)}
        >
          <Toolbar disableGutters={!this.state.drawer} className={classes.toolbar}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={() => this.toggleDrawer()}
              className={classNames(
                classes.menuButton,
                this.state.drawer && classes.menuButtonHidden,
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              Wallet
            </Typography>
            <IconButton color="inherit" onClick={() => this.logout()}>
              <ExitToApp />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.drawer && classes.drawerPaperClose),
          }}
          open={this.state.drawer}
        >
          <div className={classes.toolbarIcon}>
            <Avatar src="images/easysuki-toolbar.png" className={classes.toolbarAvatar}/>
            <IconButton onClick={() => this.toggleDrawer()} className={classes.toolbarIconButton}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          { !_.isEmpty(this.state.user) &&
            <div>
              <ListItem className={ !(this.state.user.roles.includes("admin")) && classes.hide} button onClick={() => this.goTo("Users")}>
                <ListItemIcon>
                  <PeopleIcon />
                </ListItemIcon>
                <ListItemText primary="Users" />
              </ListItem>
              <ListItem className={ !(this.state.user.roles.includes("admin") || this.state.user.roles.includes("seller")) && classes.hide} button onClick={() => this.goTo("Inventory")}>
                <ListItemIcon>
                  <StoreIcon />
                </ListItemIcon>
                <ListItemText primary="Inventory" />
              </ListItem>
              <ListItem className={ !(this.state.user.roles.includes("admin")) && classes.hide} button onClick={() => this.goTo("Config")}>
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText primary="Config" />
              </ListItem>
              <ListItem className={ !(this.state.user.roles.includes("admin") || this.state.user.roles.includes("seller")) && classes.hide} button onClick={() => this.goTo("Orders")}>
                <ListItemIcon>
                  <ShoppingCartIcon />
                </ListItemIcon>
                <ListItemText primary="Orders" />
              </ListItem>
              <ListItem selected className={ !(this.state.user.roles.includes("admin")) && classes.hide} button onClick={() => this.goTo("Tracker")}>
                <ListItemIcon>
                  <PersonPinIcon />
                </ListItemIcon>
                <ListItemText primary="Tracker" />
              </ListItem>
              <ListItem className={ !(!this.state.user.roles.includes("admin") && this.state.user.roles.includes("seller")) && classes.hide} button onClick={() => this.goTo("Wallet")}>
                <ListItemIcon>
                  <CreditCardIcon />
                </ListItemIcon>
                <ListItemText primary="Wallet" />
              </ListItem>
              <ListItem className={ !(this.state.user.roles.includes("admin") || this.state.user.roles.includes("seller")) && classes.hide} button onClick={() => this.goTo("ProductRequests")}>
                <ListItemIcon>
                  <SwapHorizIcon />
                </ListItemIcon>
                <ListItemText primary="Product Requests" />
              </ListItem>
            </div>
          }
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <div className={classes.tableContainer}>
            { this.state.loading ?
                <Paper className={classes.root}>
                  <Table className={classes.table}>
                    <LinearProgress
                      classes={{
                        colorPrimary: classes.loadingColorPrimary,
                        barColorPrimary: classes.loadingBarColorPrimary,
                      }}
                    />
                  </Table>
                </Paper>
              :
                <Paper className={classes.root}>
                  <div className={classes.div_100p}>
                    <center>Your wallet is empty</center>
                  </div>
                  { /*this.checkPayoutTableRows(payoutTableRows) ?
                      <div className={classes.div_100p}>
                        <center>Your wallet is empty</center>
                      </div>
                    :
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Transaction ID</TableCell>
                            <TableCell>Amount</TableCell><
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {payoutTableRows}
                        </TableBody>
                      </Table>*/
                  }
                </Paper>
            }
          </div>
        </main>
      </div>
    );
  }
}

Wallet.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Wallet);